import React, { useState } from 'react';
import _ from 'lodash';

import PropTypes from 'prop-types';
import { Document } from '@tds/core-decorative-icon';
import Select from '@tds/core-select';
import { Tr, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

import ValidateLoader from '../UI/validateLoader';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import {
  quoteStatus,
  vpbRateOtherEnglish,
  vpbRateOtherFrench
} from '../utils/constant';

import request, { apiHost } from '../utils/request';
import { getFormattedDate } from '../utils/utils';
import { getPathVariables } from '../misc';

const Rows = ({ order, removeData, index, pageLayout }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    quoteApprovalDashboard: {
      selectApprovedPriceError,
      selectPriceLabelDefault,
      approveButtonDefault,
      declineButtonDefault,
      validateMessage,
      vbpPricesLabel
    }
  } = localizedStrings;

  const locale = getPathVariables(window.location.pathname)[0];
  const [approvedPrice, setApprovedPrice] = useState();
  const [actionCalled, setActionCalled] = useState(false);

  /**
   * Function to convert price list
   * into json required as options
   * for the Select component
   */
  const convertToOptionsObj = priceArr => {
    const optionObj = [];
    if (priceArr) {
      priceArr.forEach(price => {
        optionObj.push({ text: `$${price}`, value: `${price}` });
      });
    }
    return optionObj;
  };

  /**
   * Function to set Approved price
   */
  const handleApprovedPrice = event => {
    setApprovedPrice(event.target.value);
  };

  /**
   * Function to handle Approve action
   */
  const handleQuoteApprove = () => {
    if (!approvedPrice) {
      // eslint-disable-next-line no-alert
      alert(selectApprovedPriceError);
      return;
    }
    setActionCalled(true);

    const updatedPayload = [vpbRateOtherEnglish, vpbRateOtherFrench].includes(
      order.vpbOfficeSeatRate
    )
      ? {
          ...order,
          vpbOfficeSeatRate: approvedPrice,
          quoteStatus: quoteStatus.approved,
          step: 1
        }
      : {
          ...order,
          vpbOfficeSeatRate: approvedPrice,
          quoteStatus: quoteStatus.approved,
          step: 1
        };

    request
      .put(`/orders/${order.id}/quote`, updatedPayload)
      .then(() => {
        removeData(order.id);
      })
      .catch(() => {
        setActionCalled(false);
      });
  };

  /**
   * Function to handle Decline action
   */
  const handleQuoteDecline = () => {
    setActionCalled(true);

    const updatedPayload = { ...order, quoteStatus: quoteStatus.incomplete };
    request
      .put(`/orders/${order.id}/quote`, updatedPayload)
      .then(() => {
        removeData(order.id);
      })
      .catch(() => {
        setActionCalled(false);
      });
  };

  const getOptions = () => {
    let result = pageLayout.prices[order.businessConnectEdition];

    if (['Voice', 'Voix'].includes(order.businessConnectEdition)) {
      result = ['Month-to-Month', 'sur une base mensuelle'].includes(
        order.contractTerm
      )
        ? result.MonthToMonth
        : result.Other;
    }

    return convertToOptionsObj(result);
  };

  return (
    <Tr style={{ background: index % 2 === 0 ? '#f9f1ff' : '#ffffff' }}>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        <a
          href={`${apiHost}/orders/${_.get(
            order,
            'id',
            ''
          )}/quote-pdf?lang=${locale}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Document />
        </a>
      </Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        {_.get(order, 'orderId', '')}
      </Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>{`${_.get(
        order,
        'first_name',
        ''
      )} ${_.get(order, 'last_name', '')}`}</Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        {_.get(order, 'typeOfInstallation', '')}
      </Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        {_.get(order, 'businessLegalName', '')}
      </Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        {parseInt(_.get(order, 'starterSeat', 0), 10) +
          parseInt(_.get(order, 'officeSeats', 0), 10)}
      </Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        $
        {[vpbRateOtherEnglish, vpbRateOtherFrench].includes(
          _.get(order, 'vpbOfficeSeatRate', '')
        )
          ? _.get(order, 'vbpDesiredPrice', '')
          : _.get(order, 'vpbOfficeSeatRate', '')}
      </Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        {order.businessConnectEdition && (
          <Select
            label={`${order.businessConnectEdition} ${vbpPricesLabel}`}
            placeholder={_.get(
              pageLayout,
              'selectPriceLabel',
              selectPriceLabelDefault
            )}
            options={getOptions()}
            onChange={handleApprovedPrice}
          />
        )}
      </Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        {getFormattedDate(
          _.get(order, 'updatedAt', '2020-07-25T21:03:27.000Z'),
          'YYYY-MM-DD, h:mm a'
        )}
      </Td>
      <Td style={{ borderRight: '1px solid #e7e7e7', display: 'flex' }}>
        {actionCalled ? (
          <ValidateLoader message={validateMessage} />
        ) : (
          <>
            <button
              type="button"
              className="frg-button color-green"
              onClick={handleQuoteApprove}
            >
              {_.get(pageLayout, 'actionApproveLabel', approveButtonDefault)}
            </button>
            <button
              type="button"
              className="frg-button color-purple"
              style={{ marginLeft: '1rem' }}
              onClick={handleQuoteDecline}
            >
              {_.get(pageLayout, 'actionDeclineLabel', declineButtonDefault)}
            </button>
          </>
        )}
      </Td>
    </Tr>
  );
};

Rows.propTypes = {
  order: PropTypes.objectOf(PropTypes.object).isRequired,
  removeData: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  pageLayout: PropTypes.objectOf(PropTypes.object).isRequired
};

export default Rows;
